import request from '@/utils/request'

export function getMenuList(params) {
  return request({
    url: '/rbac/v1/menus/tree',
    method: 'get',
    params,
  })
}
